import gql from "graphql-tag";
import client from "@/data/client"

let retry = (fn, retries=3, err=null) => {
  if(!retries) {
    return Promise.reject(err)
  }
  return fn().catch(err => {
    return retry(fn, (retries - 1), err)
  })
}

const service = {
  isAwake() {
    return new Promise((resolve) => {
      client.api
        .query({
          query: gql `
            query isAwake
            {
              isAwake{
                id
              }
            }
          `
        })
        .then(response => {
          resolve(response.data.isAwake)
        })
        .catch(err => {
          const error = err.graphQLErrors.map((error) => {
            return error.message
          })
          console.log(error)
        })
    })
  },
  getSeason(id) {
    let fn = function() {
      return new Promise((resolve) => {
        client.api
          .query({
            query: gql `
              query getSeason {
                getSeason(id:${id}) {
                  description
                  end_date
                  facilities {
                    facility_name
                    facility_type
                    id
                  }
                  id
                  priority_start_date
                  priority_too_early
                  season
                  season_registration_setup {
                    age_group
                    division_name
                    id
                    registration_end_date
                    registration_start_date
                    timing_status
                  }
                  season_type
                  sport
                  start_date
                  status
                  year
                }
              }
            `
          })
          .then(response => {
            resolve(response.data.getSeason)
          })
      })
    }
    return retry(fn)
  },
  listSeasons() {
    let fn = function() {
      return client.api.query({
        query: gql `
          query listSeasons {
            listSeasons {
              end_date
              id
              season
              season_type
              sport
              start_date
              status
              year
            }
          }
        `
      }).then(response => response.data.listSeasons)
    }
    return retry(fn)
  },
  getFacility(seasonId, facilityId) {
    let fn = function() {
      return new Promise((resolve) => {
        client.api
          .query({
            query: gql `
              query getFacility {
                getFacility(id:${facilityId}, season_id:${seasonId}) {
                  address
                  athletic_space {
                    athletic_space_breakouts {
                      id
                      name
                    }
                    door
                    facility_hours {
                      end_dtm
                      id
                      season_id
                      session {
                        id
                        reservations {
                          id
                          team_id
                          breakout_id
                        }
                        session_end_dtm
                        session_start_dtm
                      }
                      slot_minutes
                      start_dtm
                      week_day
                    }
                    facility_hours_schedule {
                      end_dtm
                      id
                      slot_minutes
                      start_dtm
                      week_day
                    }
                    gym_basket_detail {
                      adjustable
                      basket_height
                      basket_type
                      comments
                      id
                      location_crank
                      setup
                    }
                    id
                    name
                    slots
                    sport
                    status
                  }
                  description
                  facility_name
                  facility_type
                  id
                  last_update
                  last_update_by
                  status
                }
              }
            `
          })
          .then(response => {
            resolve(response.data.getFacility)
          })
      })
    }
    return retry(fn)
  },
  getCoach(id) {
    let fn = function() {
      return client.api.query({
        query: gql `
          {
            getCoach(id:"${id}") {
              id
              name
              teams {
                id
                division_name
                reservations {
                  id
                  slots
                  breakout {
                    name
                  }
                  session {
                    id
                    session_start_dtm
                    session_end_dtm
                    facility_hours {
                      id
                      week_day
                      start_dtm
                      end_dtm
                      athletic_space {
                        id
                        name
                        sport
                        facility {
                          id
                          facility_name
                        }
                      }
                    }
                  }
                }
                season_id
                team_name
              }
            }
          }
        `
      }).then(response => response.data.getCoach)
    }
    return retry(fn)
  },
  listCoaches(season_id) {
    let fn = function() {
      return client.api.query({
        query: gql `
          query listCoaches {
            listCoaches(season_id:"${season_id}") {
              id
              email
            }
          }
        `
      }).then(response => response.data.listCoaches)
    }
    return retry(fn)
  },
  getSession(id) {
    let fn = function(){
      return client.api.query({
        query: gql `
          {
            getSession(id:"${id}") {
              facility_hours {
                athletic_space {
                  slots
                  athletic_space_breakouts {
                    id
                    name
                  }
                }
              }
              reservations {
                team_id
                slots
                breakout_id
              }
            }
          }
        `
      }).then(response => response.data.getSession)
    }
    return retry(fn)
  },
  createReservation(sessionId, teamId, breakout_id=null) {
    let fn = function(){
      return client.api.mutate({
        variables: {
          session_id: sessionId,
          team_id: teamId,
          breakout_id: breakout_id
        },
        mutation: gql `
          mutation createReservation($session_id: Int, $team_id: Int, $breakout_id: Int)
          {
            createReservation(input:{session_id:$session_id,team_id:$team_id,breakout_id:$breakout_id})
          }
        `
      }).then(response => response.data.createReservation)
    }
    return retry(fn)
  },
  deleteReservation(sessionId, teamId) {
    let fn = function() {
      return client.api.mutate({
        variables: {
          session_id: sessionId,
          team_id: teamId
        },
        mutation: gql `
          mutation deleteReservation($session_id: Int, $team_id: Int)
          {
            deleteReservation(input:{session_id:$session_id,team_id:$team_id})
          }
        `
      })
    }
    return retry(fn)
  }
}

export default service;
